import React from 'react';
import ReactApexChart from 'react-apexcharts';
import useReactApexChart from '../../hook/useReactApexChart';

const LeadCetegaryOverview = () => {
    let { leadGeneratedonutChartOptions, leadGeneratedonutChartSeries } = useReactApexChart();
    return (
        <div className="col-xxl-4">
            <div className="card h-100 radius-8 border-0 overflow-hidden">
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="mb-2 fw-bold text-lg">Lead Cetegary Overview</h6>

                    </div>
                    <div className='position-relative'>
                        <ReactApexChart options={leadGeneratedonutChartOptions} series={leadGeneratedonutChartSeries} type="donut" height={200} />
                        <div className="position-absolute start-50 top-50 translate-middle">
                            <span className="text-xs text-secondary-light fw-medium">
                                Total Leads
                            </span>
                            <h4 className="mb-0 text-center text-lg">80</h4>
                        </div>
                    </div>
                    <div className="row mt-3 align-items-center">
                        <div className="col-6">
                            <div className="d-flex align-items-center gap-2" style={{ width: '120px' }}>
                                <span className="w-11-px h-11-px radius-2 " style={{ background: "#0866ff" }} />
                                <span className="text-secondary-light text-sm fw-normal">
                                    Facebook: <span className="text-primary-light fw-semibold">20</span>
                                </span>
                            </div>
                        </div>
                        <div className="col-6 d-flex justify-content-end">
                            <div className="d-flex align-items-center gap-2" style={{ width: '120px' }}>
                                <span className="w-11-px h-11-px radius-2 " style={{ background: "#ff6c00" }} />
                                <span className="text-secondary-light text-sm fw-normal">
                                    Just diel: <span className="text-primary-light fw-semibold">15</span>
                                </span>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="d-flex align-items-center gap-2" style={{ width: '120px' }}>
                                <span className="w-11-px h-11-px radius-2 " style={{ background: "#1e95c3" }} />
                                <span className="text-secondary-light text-sm fw-normal">
                                    Website: <span className="text-primary-light fw-semibold">10</span>
                                </span>
                            </div>
                        </div>
                        <div className="col-6 d-flex justify-content-end">
                            <div className="d-flex align-items-center gap-2" style={{ width: '120px' }}>
                                <span className="w-11-px h-11-px radius-2 " style={{ background: "#fabb05" }} />
                                <span className="text-secondary-light text-sm fw-normal">
                                    Google ads: <span className="text-primary-light fw-semibold">05</span>
                                </span>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="d-flex align-items-center gap-2" style={{ width: '120px' }}>
                                <span className="w-11-px h-11-px radius-2 " style={{ background: "#767676" }} />
                                <span className="text-secondary-light text-sm fw-normal">
                                    Manually: <span className="text-primary-light fw-semibold">15</span>
                                </span>
                            </div>
                        </div>
                        <div className="col-6 d-flex justify-content-end">
                            <div className="d-flex align-items-center gap-2" style={{ width: '120px' }}>
                                <span className="w-11-px h-11-px radius-2 " style={{ background: "#25d366" }} />
                                <span className="text-secondary-light text-sm fw-normal">
                                    Watsapp: <span className="text-primary-light fw-semibold">15</span>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default LeadCetegaryOverview